if (!customElements.get("collection-tabs")) {
  customElements.define(
    "collection-tabs",
    class CollectionTabs extends HTMLElement {
      slidesConfig = {
        freeScroll: true,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        groupCells: true,
        imagesLoaded: true,
        cellAlign: "left",
      };
      constructor() {
        super();

        this.hasCarousels = this.dataset.grid === "true";
        this.namespace = this.dataset.sectionId;
        this.slidesConfig.prevNextButtons = this.dataset.arrows === "true";
      }
      connectedCallback() {
        const tabCount = Number(this.dataset.tabCount);
        this.carousels = Array(tabCount).fill(null);
        this.carouselGrids = this.querySelectorAll(
          ".carousel-overflow-wrapper .grid",
        );

        this.tablist = this.querySelector('[role="tablist"]');
        this.tabs = this.tablist.querySelectorAll('[role="tab"]');
        this.panels = this.querySelectorAll('[role="tabpanel"]');

        this.active = {
          tab: this.tabs[0],
          panel: this.panels[0],
          carousel: this.carousels[0],
        };

        const sectionEl = this.parentElement;
        const sectionIndex = [].indexOf.call(
          sectionEl.parentElement.children,
          sectionEl,
        );

        if (sectionIndex === 0) {
          this.init();
        } else {
          theme.initWhenVisible({
            element: this,
            callback: this.init.bind(this),
          });
        }
      }
      disconnectedCallback() {
        this.carousels.forEach((c) => {
          if (c !== null && typeof c.destroy === "function") c.destroy();
        });
        window.off("resize." + this.namespace);
      }

      init() {
        this.tabs.forEach(this.setTabEvents.bind(this));

        if (this.hasCarousels) {
          this.initializeCarousel(0);
          window.on(
            "resize." + this.namespace,
            theme.utils.debounce(300, this.carouselResize.bind(this)),
          );
        }
      }

      setTabEvents(tab, idx) {
        tab.addEventListener("click", () => this.activateTab(tab));
        tab.addEventListener("keydown", (event) => {
          let newIndex = null;
          switch (event.key) {
            case "ArrowRight":
              newIndex = (idx + 1) % this.tabs.length;
              break;
            case "ArrowLeft":
              newIndex = (idx - 1 + this.tabs.length) % this.tabs.length;
              break;
            case "Home":
              newIndex = 0;
              break;
            case "End":
              newIndex = this.tabs.length - 1;
              break;
            case "Enter":
            case " ":
              activateTab(tab);
              return;
            default:
              return;
          }

          event.preventDefault();
          this.activateTab(this.tabs[newIndex]);
        });
      }

      activateTab(tab) {
        this.tabs.forEach((t) => {
          t.setAttribute("aria-selected", "false");
          t.setAttribute("tabindex", "-1");
        });

        this.panels.forEach((panel) => {
          panel.classList.add("hide");
        });

        tab.setAttribute("aria-selected", "true");
        tab.setAttribute("tabindex", "0");
        tab.focus();

        const panelId = tab.getAttribute("aria-controls");
        this.querySelector(`#${panelId}`).classList.remove("hide");

        const index = Number(tab.dataset.index);
        this.active.tab = this.tabs[index];
        this.active.panel = this.panels[index];
        if (this.hasCarousels) {
          if (this.carousels[index] === null) this.initializeCarousel(index);
          else {
            this.active.carousel = this.carousels[index];
            this.active.carousel.resize();
          }
        }
      }

      initializeCarousel(index) {
        this.avoidReflow(this.active.panel);
        this.carousels[index] = new Flickity(
          this.carouselGrids[index],
          this.slidesConfig,
        );
        this.active.carousel = this.carousels[index];
      }

      carouselResize() {
        this.active.carousel.resize();
      }

      avoidReflow(el) {
        const style = document.createElement("style");
        style.innerHTML = `#${el.id} .flickity-viewport{height:${el.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    },
  );
}
